<!-- Header -->
<div class="flex flex-col h-full">
  <div class="flex text-base items-center font-semibold border-b border-gray-1 p-3 pb-2">
    <div class="flex flex-1">Saved Measurements</div>
    <button modus-icon-button (click)="toggleExpand.emit()">
      <md-icon class="transition-transform duration-300" [ngClass]="{ 'rotate-180': expanded }"
        >expand_less</md-icon
      >
    </button>
  </div>

  <div class="flex justify-end p-3">
    <modus-button
      button-style="outline"
      color="secondary"
      modus-tooltip="Create new measurement"
      (click)="measure()"
    >
      Create New
    </modus-button>
  </div>

  <!-- Loader -->
  @if (measurements.length === 0) {
    <div class="flex flex-1">
      <nzc-busy-indicator [busy]="loading">
        <!-- No items -->
        <div class="flex flex-1 flex-col justify-center items-center text-center px-3 pb-9">
          <div class="text-base font-semibold">No measurements</div>
          <div class="text-sm mt-2">
            Looks like you haven't saved any measurements yet. Start by creating a new measurement.
          </div>
        </div>
      </nzc-busy-indicator>
    </div>
  } @else {
    <!-- List -->
    <div class="flex flex-col pb-3 overflow-y-auto">
      @for (measurement of measurements; track measurement.id) {
        <div class="flex flex-row min-h-8 text-sm hover:bg-gray-0 px-2">
          <!-- Icon -->
          <div class="w-8">
            @switch (measurement.state) {
              @case (MeasurementDisplayStatus.Hidden) {
                <button
                  modus-icon-button
                  modus-tooltip="Show measurement"
                  tooltipClass="arrow-left"
                  (click)="toggleMeasurement(measurement)"
                >
                  <i class="tc-icon-eye-visibility-off-download opacity-60"></i>
                </button>
              }
              @case (MeasurementDisplayStatus.Visible) {
                <button
                  modus-icon-button
                  modus-tooltip="Hide measurement"
                  tooltipClass="arrow-left"
                  (click)="toggleMeasurement(measurement)"
                >
                  <i class="tc-icon-eye-visibility"></i>
                </button>
              }
            }
          </div>

          <!-- Text -->
          <div
            modus-tooltip="{{ measurement.name }}"
            class="flex items-center w-full overflow-hidden p-1"
          >
            <div class="w-full overflow-hidden text-ellipsis whitespace-nowrap">
              {{ measurement.name }}
            </div>
          </div>

          <!-- Options -->
          <div class="flex flex-row items-center">
            <!-- Menu -->
            <button modus-icon-button [modusMenuTriggerFor]="measurementMenu">
              <md-icon>more_vertical</md-icon>
            </button>
            <md-menu #measurementMenu>
              <md-menu-item
                (itemClick)="editMeasurement(measurement)"
                [disabled]="measurement.deleting"
                >Edit</md-menu-item
              >
              <md-menu-item
                (itemClick)="deleteMeasurement(measurement)"
                [disabled]="measurement.deleting"
                >Delete</md-menu-item
              >
            </md-menu>
          </div>
        </div>
      }
    </div>
  }
</div>
